<template>
    <div class="detail">
         <!-- banner -->
        <banner title="服务体系" :content="content" type="3" />
        <div class="body" v-if="width >= 1200">
            <!-- 导航栏 -->
            <div class="nav">
            服务体系 <i class="el-icon-arrow-right"></i> {{ itype == 1? '社区心理服务体系' : itype == 2? '学校心理服务体系' : itype == 3? 'EAP服务体系' : '社会工作和公益服务体系'}} <i class="el-icon-arrow-right"></i> <span style="color:#3DCDD0;font-size: 24px">详情</span>
            </div>
            <div style="font-size: 30px;margin:10px 0 30px 0">{{ title }}</div>
            <!-- <div style="padding: 0 100px;">
                <div class="title">第二届中国社会心理服务高峰论坛与会专家 参观瑞阳心语基地</div>
                <p>&emsp;&emsp;随着经济水平的提高，公众心理压力普遍增加，居民对心理健康和精神卫生的服务需求明显增加，出现多元化与低龄化的趋势。中国科学院心理研究所发布的《中国国民心理健康发展报告（2021-2022)》蓝皮书指出，心理健康风险上升为全球十大风险之一。在2022年的国民心理健康状况的调查中，抑郁风险检出率为10.6%，焦虑风险检出率为15.8%，首要影响因素为年龄和收入；在成年人群中，青年为抑郁的高发风险群体，18-24岁年龄组检出率高达24.1%。</p>
                <p>党的二十大报告中明确提出要“把保障人民健康放在优先发展的战略位置”，“重视心理健康和精神卫生”，“建设更高水平的平安中国”的要求。近年来，党中央、国务院高度重视社会心理服务工作，中央“两办”印发的《关于建设更高水平的平安中国的意见》和《“健康中国2030”规划纲要》都将心理服务工作作为重要内容，提出明确工作要求。2018年11月，10部委联合下发《关于印发全国社会心理服务体系建设试点工作方案的通知》，在全国范围内开展社会心理服务体系建设试点工作。一系列政策文件的发布实施，为心理健康工作提供了强有力的保障。</p>
                <div class="title">服务对象</div>
                <p>全体观众</p>
                <div class="title">工作模式</div>
                <p>党政领导+部门协调+社会参与+专业服务+学术支持</p>
                <div class="title">服务项目</div>
                <p>社会心理服务（全生态一体化）解决方案=平台+空间+培训+服务：1.平台：社会心理服务智慧PaaS+SaaS+X云平台2.空间：N个数字化心理服务物理空间建设3.培训:人才培养、人才培训、人才选拔4.服务：个体服务、家庭服务、群体服务、组织服务</p>
                <div class="title">服务成效</div>
                <p>        近年来，瑞阳心语积极投身于社会心理服务实践，已面向2000多个社区开展心理服务，发放心理科普科普宣传折页、手册和书籍等资料60000余份，开展心理科普讲座和团体活动3800余场，服务重点人群5000余人和特殊人群300余人，受益人群覆盖100万人，打通了心理服务的“最后一米”。</p>
                <div class="bigimg">
                    <div class="imgs" v-for="(item,index) in imglist" :key="index">
                    <img :src="item.url" alt="">
                </div>
            </div> -->
          <div class=" ql-editor ql-container ql-snow" style=" width: 1440px;margin: 50px auto;">
            <div v-html="content"></div>
          </div>
        </div>
        <div style="padding:10px" v-if="width <= 768">
            <div class="nav" style="font-size:18px;">
            服务体系 <i class="el-icon-arrow-right"></i> {{ itype == 1? '社区心理服务体系' : itype == 2? '学校心理服务体系' : itype == 3? 'EAP服务体系' : '社会工作和公益服务体系'}} <i class="el-icon-arrow-right"></i> <span style="color:#3DCDD0">详情</span>
            </div>
            <div style="font-size: 12px;margin:10px 0 30px 0">{{ title }}</div>
          <div class=" ql-editor ql-container ql-snow" style=" width: 1440px;margin: 0 auto;">
            <div v-html="content"></div>
          </div>
        </div>
    </div>
    <!-- </div> -->
</template>

<script>
import Banner from "../components/Banner";
import { getArticle } from '../api/api'
export default {
    components: {
        Banner
    },
    data () {
        return {
            // content:`社区心理服务体系\n学校心理服务体系\nEAP心理服务体系\n社会工作和公益服务体系`,
            imglist:[
                // {
                //     url:require('../assets/img/consultationDetailsone.png')
                // },
                // {
                //     url:require('../assets/img/consultationDetailstwo.png')
                // },
                // {
                //     url:require('../assets/img/consultationDetailsthree.png')
                // },
            ],
            id:"",
            content:"",
            title:"",
            createTime:"",
            itype:'',
            width:document.documentElement.clientWidth
        }
    },
    mounted () {
        window.onresize = () => {
       return (() => {
         this.width = document.documentElement.clientWidth // 宽
       })
    }
        this.id = this.$route.query.id
        this.itype = this.$route.query.itype
        getArticle(this.id).then(res => {
            this.content = res.data.data.content
            this.title = res.data.data.title
            this.createTime = res.data.data.createTime
        })
    }
}
</script>

<style lang="scss" scoped>
 @import url('../assets/font/font.css');
 * {
        margin: 0;
        padding: 0;
        font-family: Microsoft YaHei;
   font-size: 16px;
    }
 @media (min-width:1200px) {
    .detail{
        width: 100%;
        height: 100%;
    }
    .body{
        width: 1440px;
        margin: 0 auto;
        box-sizing: border-box;
        box-sizing: border-box;


        .nav{
            width: 100%;
            box-sizing: border-box;
            padding: 30px 0;
            font-size: 24px;
            color: #909090;
        }
        .title{
            font-size: 24px;
            color: #000000;
            text-align:center;
            margin: 30px 0;
        }

        P{
            font-size: 14px;
            color: #000000;
            // margin: 20px 0;
        }
        .bigimg{
            width: 100%;
            display: flex;
            justify-content: space-between;
            // flex-direction: column;
            // align-items: center;
            margin-bottom:50px;
        }
        .imgs{
            width: 33%;
            margin-top: 50px;
            img{
                width: 100%;
                height: 100%;
            }
        }
    }
 }
 @media (max-width: 1200px) {
  P {
    font-size: 12px;
    color: #000000;
  }
  ::v-deep .content {
    p {
      img {
        width: 95% !important;
        height: 200px !important;
        // margin: 0 auto !important;
        margin-left: 10px;
      }
    }

    .ql-align-center {
      // margin: 0 auto !important;
      text-align: center;

      img {
        width: 100% !important;
        height: 200px !important;
      }
    }
  }
}

</style>
